import React from 'react';
import styled from 'styled-components';
import { Flex, Typo, theme } from '../../../../ui';
import TeacherOverviewWidget from './TeacherOverviewWidget';
import PendingEvaluationsWidget from './PendingEvaluationsWidget';
import StudentActivityWidget from './StudentActivityWidget';
import QuickActionsWidget from './QuickActionsWidget';
import EditableCoursesWidget from './EditableCoursesWidget';
import ListCourses from '../../../../components/ListCourses';
import WelcomeMessage from '../WelcomeMessage';
import WelcomeRow from '../WelcomeRow';
import { MOCK_PENDING_EVALUATIONS, MOCK_STUDENT_ACTIVITY, MOCK_COURSE_STATS } from './mockTeacherData';
import { media } from '../../../../utils/media';
import PageSection from '../../../../ui/Page/PageSection';

const DashboardContainer = styled(Flex)`
  width: 100%;
  padding: 0 0 40px;

  ${media.lessThan('tablet')} {
    padding: 0 0 32px;
  }
`;

const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${theme.colors.NEU_100};
  margin: 32px 0;
`;

const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;
  margin-bottom: 24px;

  ${media.lessThan('bigTablet')} {
    grid-template-columns: 1fr;
  }
`;

/**
 * TeacherDashboardContent Component
 *
 * Teacher dashboard featuring:
 * - Teaching overview with key metrics
 * - Pending evaluations to review
 * - Recent student activity
 * - Quick actions (invite, create, etc.)
 * - Editable courses list (real data)
 *
 * Combines real course data with mock data for new features.
 */
const TeacherDashboardContent = ({ dashboardData = [], isLoading = false }) => {
  // Filter courses teacher can edit
  const editableCourses = dashboardData.filter((course) => course.canEdit);

  return (
    <DashboardContainer direction='column' align='flex-start'>
      {/* Welcome + Teaching Overview */}
      <PageSection>
        <WelcomeRow>
          <WelcomeMessage role={'teacher'} />
          <TeacherOverviewWidget stats={MOCK_COURSE_STATS} coursesCount={editableCourses.length} />
        </WelcomeRow>

        {/* Editable Courses - Uses Real Data */}
        {isLoading && !dashboardData.length ? <ListCourses isLoading={true} /> : <EditableCoursesWidget courses={dashboardData} />}

        <SectionDivider />

        {/* Two Column Layout: Pending Evaluations + Student Activity */}
        <TwoColumnLayout>
          <PendingEvaluationsWidget evaluations={MOCK_PENDING_EVALUATIONS} />
          <StudentActivityWidget activities={MOCK_STUDENT_ACTIVITY} />
        </TwoColumnLayout>

        {/* Quick Actions - Full Width */}
        <QuickActionsWidget />
      </PageSection>
    </DashboardContainer>
  );
};

export default TeacherDashboardContent;
